import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'produto-item-two',
  templateUrl: './produto-item-two.component.html',
  styleUrls: ['./produto-item-two.component.scss']
})
export class ProdutoItemTwoComponent implements OnInit {

  @Input("solicitarPassageiros") solicitarPassageiros:any   = false;
  @Input("hash") hash:any                                   = null; 
  @Input("servico") servico:any                             = null;
  @Input("template") template:any                           = "one"; 
  public defaultImage                                       = "/images/produto/sem-foto/brocker.jpg";

  constructor(){ } 

  /**
   * 
   * Incializa as Funções
   * 
   */
  ngOnInit():void{}

}
